import { useState } from "react";
import AgentsAPI from "../../../api/AgentsAPI";

const useUpdateNotificationPreferences = () => {
	const [loading, setLoading] = useState(false);

	const updateNotificationPreferences = async (preferences) => {
		setLoading(true);

		try {
			const result = await AgentsAPI.updateNotificationPreferences(preferences);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update notification preferences:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateNotificationPreferences,
		loading,
	};
};

export default useUpdateNotificationPreferences;
